import React from 'react';
import { TypographyProps } from '@mui/material';
import breakpoints from 'theme/breakpoints';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';
import {
  fontStylesByVariant,
  fontStylesByVariantMobile,
  FontVariants,
} from './Typography.config';
import * as Styled from './Typography.styles';

export type TypographyComponentProps = Omit<TypographyProps, 'variant'> & {
  color?: string;
  fontSize?: number | string;
  variant?: FontVariants;
  content?: React.ReactNode | string;
  component?: React.ElementType;
  responsiveBreakpoint?: 'sm' | 'md' | 'lg';
  href?: string;
  inherit?: boolean;
};

const TypographyComponent: React.FC<TypographyComponentProps> = ({
  variant = 'body',
  fontWeight,
  fontSize,
  children,
  color = palette.primary.main,
  responsiveBreakpoint,
  inherit,
  ...restProps
}) => {
  const { values } = breakpoints;
  let fontSizes = fontStylesByVariant;

  if (responsiveBreakpoint != null && values[responsiveBreakpoint] != null) {
    fontSizes =
      window.innerWidth <= values[responsiveBreakpoint]
        ? fontStylesByVariantMobile
        : fontStylesByVariant;
  }

  const computedFontSize =
    variant != null && fontSize == null
      ? fontSizes?.[variant]?.fontSize || fontSize
      : fontSize;
  const fontSizeInEm = pxToEm(computedFontSize);
  const lineHeight =
    variant != null
      ? pxToEm(
          fontSizes?.[variant]?.lineHeight,
          false,
          Number(computedFontSize),
        )
      : undefined;

  return (
    <Styled.Typography
      fontWeight={inherit ? 'inherit' : fontWeight}
      fontSize={inherit ? 'inherit' : fontSizeInEm}
      lineHeight={inherit ? 'inherit' : lineHeight}
      color={inherit ? 'inherit' : color}
      {...restProps}
    >
      {children}
    </Styled.Typography>
  );
};

export default TypographyComponent;
